module.exports = __webpack_public_path__ + "static/media/logo-group.47995e91.png";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/logo-group.png
// module id = 992
// module chunks = 0